var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 33V9C46 7.674 45.473 6.40199 44.536 5.46399C43.598 4.52699 42.326 4 41 4H23.618L23 2.76401C22.153 1.07001 20.422 0 18.528 0H5C2.239 0 0 2.239 0 5V33C0 35.761 2.239 38 5 38H41C42.326 38 43.598 37.473 44.536 36.536C45.473 35.598 46 34.326 46 33ZM44 13V33C44 33.796 43.684 34.559 43.121 35.121C42.559 35.684 41.796 36 41 36C32.633 36 13.367 36 5 36C3.343 36 2 34.657 2 33V5C2 3.343 3.343 2 5 2H18.528C19.664 2 20.703 2.64199 21.211 3.65799L24.106 9.44699C24.275 9.78599 24.621 10 25 10H41C41.796 10 42.559 10.316 43.121 10.879C43.684 11.441 44 12.204 44 13ZM24.618 6L25.618 8H41C42.088 8 43.14 8.355 44 9C44 8.204 43.684 7.441 43.121 6.879C42.559 6.316 41.796 6 41 6H24.618Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.801cbe1d93753d4b24a4eaa48022a528.svg";
export { ForwardRef as ReactComponent };